module.exports = __webpack_public_path__ + "img/inactive-enaira-option.f1436987.svg";